function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function onEntry(entry) {
  entry.forEach(function (change) {
    if (change.isIntersecting) {
      change.target.classList.add('element-show');
    }
  });
}
var options = {
  rootMargin: '0px 0px 80% 0px',
  threshold: [0]
};
var observer = new IntersectionObserver(onEntry, options);
var elements = document.querySelectorAll('.animation');
var _iterator = _createForOfIteratorHelper(elements),
  _step;
try {
  for (_iterator.s(); !(_step = _iterator.n()).done;) {
    var elm = _step.value;
    observer.observe(elm);
  }
} catch (err) {
  _iterator.e(err);
} finally {
  _iterator.f();
}
function onEntry1(entry) {
  entry.forEach(function (change) {
    if (change.isIntersecting) {
      change.target.classList.add('element-show');
    }
  });

  //NUMBER
  function NumberCounter1() {
    var totalNumber = document.querySelector('.global__card-number:nth-child(1)');
    //console.log(totalNumber.dataset.number);
    var startCount = 0;
    var counterUP = function counterUP() {
      startCount += 10;
      totalNumber.innerHTML = "".concat(startCount);
      if (startCount == totalNumber.dataset.number) {
        clearInterval(countStop);
      }
    };
    // let countStop = setInterval(() => {
    //     counterUP();
    // },100);
  }

  function NumberCounter2() {
    var totalNumber = document.querySelector('.global__card:nth-child(2) .global__card-number');
    //console.log(totalNumber.dataset.number);
    var startCount = 0;
    var counterUP = function counterUP() {
      startCount += 1000;
      totalNumber.innerHTML = "".concat(startCount) + '+';
      if (startCount == totalNumber.dataset.number) {
        clearInterval(countStop);
      }
    };
    // let countStop = setInterval(() => {
    //     counterUP();
    // },100);
  }

  function NumberCounter3() {
    var totalNumber = document.querySelector('.global__card:nth-child(3) .global__card-number');
    //console.log(totalNumber.dataset.number);
    var startCount = 0;
    var counterUP = function counterUP() {
      startCount++;
      totalNumber.innerHTML = "".concat(startCount);
      if (startCount == totalNumber.dataset.number) {
        clearInterval(countStop);
      }
    };
    // let countStop = setInterval(() => {
    //     counterUP();
    // },100);
  }

  //   NumberCounter1()
  //   NumberCounter2()
  //   NumberCounter3()
}

var optionsRight = {
  rootMargin: '50px',
  threshold: [0]
};
var observerRight = new IntersectionObserver(onEntry1, optionsRight);
var elements1 = document.querySelectorAll('.fadeInRight');
var _iterator2 = _createForOfIteratorHelper(elements1),
  _step2;
try {
  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
    var _elm = _step2.value;
    observerRight.observe(_elm);
  }
} catch (err) {
  _iterator2.e(err);
} finally {
  _iterator2.f();
}